import React from 'react';
import { Check } from 'lucide-react';

/**
 * The 1/2/3/4 step-dots row at the top of the booking flow.
 * Skips the "Choose barber" dot when the shop only has one barber
 * or has disabled the choose-a-barber toggle.
 */
export const StepsHeader = ({ step, showBarberStep }) => (
  <div className="booking-steps">
    <div className={`step ${step >= 1 ? 'active' : ''} ${step > 1 ? 'complete' : ''}`}>
      {step > 1 ? <Check size={16} /> : '1'}
    </div>
    <div className="step-line"></div>
    {showBarberStep && (
      <>
        <div className={`step ${step >= 2 ? 'active' : ''} ${step > 2 ? 'complete' : ''}`}>
          {step > 2 ? <Check size={16} /> : '2'}
        </div>
        <div className="step-line"></div>
      </>
    )}
    <div className={`step ${step >= 3 ? 'active' : ''} ${step > 3 ? 'complete' : ''}`}>
      {step > 3 ? <Check size={16} /> : showBarberStep ? '3' : '2'}
    </div>
    <div className="step-line"></div>
    <div className={`step ${step >= 4 ? 'active' : ''}`}>
      {showBarberStep ? '4' : '3'}
    </div>
  </div>
);
